import theme from "../../config/theme"

export const themePalette = theme.palette
export const borderRadiusBoxes = `${theme.borderRadiusBoxes.borderRadius}px`

// Estilo base de la insignia que indica el acceso a la nube.
export const cloudBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.25rem",
  padding: "0.125rem 0.5rem",
  borderRadius: borderRadiusBoxes,
  fontSize: "0.75rem",
}

// Devuelve la apariencia del badge segun el estado activo del medidor.
export const activeBadgeStyle = (active) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.25rem",
  padding: "0.125rem 0.5rem",
  borderRadius: borderRadiusBoxes,
  fontSize: "0.75rem",
  backgroundColor: active ? themePalette.status.successSoft : themePalette.error.light,
  color: active ? themePalette.status.success : themePalette.error.main,
  border: active ? `1px solid ${themePalette.border.muted}` : `1px solid ${themePalette.error.light}`,
})

// Tarjeta base para los bloques del panel derecho.
export const detailCardSx = {
  display: "flex",
  flexDirection: "column",
  rowGap: "0.7rem",
  padding: "0.85rem",
  borderRadius: borderRadiusBoxes,
  border: `1px solid ${themePalette.border.main}`,
  background: `linear-gradient(180deg, ${themePalette.common.white} 0%, ${themePalette.surface.soft} 100%)`,
  boxShadow: themePalette.shadow.card,
}

// Variante de tarjeta para filas de informacion resumida.
export const detailInfoCardSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "0.75rem",
  padding: "0.5rem 1rem",
  borderRadius: borderRadiusBoxes,
  border: `1px solid ${themePalette.border.soft}`,
  backgroundColor: themePalette.surface.soft,
}

// Insignia visual para datos complementarios del dispositivo.
export const detailPillSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.25rem",
  padding: "0.125rem 0.5rem",
  borderRadius: borderRadiusBoxes,
  fontSize: "0.75rem",
  fontWeight: 600,
  border: `1px solid ${themePalette.border.muted}`,
  backgroundColor: themePalette.common.white,
  color: themePalette.text.secondary,
}

// Insignia visual del modelo del dispositivo.
export const modelBadgeSx = {
  ...detailPillSx,
  backgroundColor: "rgba(13, 148, 136, 0.1)",
  borderColor: "rgba(13, 148, 136, 0.22)",
  color: "#0f766e",
}

// Contenedor visual del buscador principal.
export const searchInputWrapperSx = {
  display: "flex",
  alignItems: "center",
  gap: "0.6rem",
  padding: "0.5rem 0.5rem 0.5rem 0.5rem",
  borderRadius: borderRadiusBoxes,
  background: `linear-gradient(180deg, ${themePalette.common.white} 0%, ${themePalette.surface.soft} 100%)`,
  boxShadow: themePalette.shadow.search,
}

// Boton acento reutilizable para acciones breves.
export const iconAccentButtonSx = {
  width: "2.3rem",
  height: "2.3rem",
  borderRadius: borderRadiusBoxes,
  border: `1px solid ${themePalette.surface.accentBorder}`,
  backgroundColor: themePalette.surface.accentSoft,
  color: themePalette.primary.main,
  boxShadow: themePalette.shadow.accent,
  transition: "background-color 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 160ms ease",
  "&:hover": {
    backgroundColor: themePalette.surface.selected,
    borderColor: themePalette.primary.main,
    color: themePalette.primary.dark,
    boxShadow: "0 6px 14px rgba(37, 134, 188, 0.18)",
  },
}

// Barra superior sticky del panel izquierdo.
export const searchToolbarStickySx = {
  position: "sticky",
  top: 0,
  zIndex: 12,
  borderBottom: `1px solid ${themePalette.border.overlay}`,
  background: themePalette.surface.stickyGradient,
  backdropFilter: "blur(8px)",
  boxShadow: themePalette.shadow.sticky,
}

// Tarjeta compacta para mostrar resumen del plan dentro del TopNav.
export const topNavSummaryCardSx = {
  display: "flex",
  alignItems: "stretch",
  justifyContent: "flex-start",
  gap: "0.9rem",
  padding: "0.45rem 0.7rem",
  borderRadius: "4px",
  boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.08)",
  marginBottom: "-4px",
}

export const planInfoContentSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "0.85rem",
  minWidth: 0,
  flexWrap: "nowrap",
}

export const metersUsageTrackSx = {
  display: "flex",
  alignItems: "center",
  width: "210px",
  minWidth: "180px",
  flex: "0 0 auto",
}

export const metersUsageBarSx = {
  position: "relative",
  width: "100%",
  height: "0.5rem",
  minWidth: "110px",
  borderRadius: "9999px",
  overflow: "hidden",
  backgroundColor: "#739ab2",
}

export const metersUsageFillSx = {
  position: "absolute",
  inset: 0,
  width: "70%",
  borderRadius: "9999px",
  background: "linear-gradient(90deg, #4abef0 0%, #4abef0 100%)",
}

export const planInfoDividerSx = {
  width: "1px",
  height: "1rem",
  backgroundColor: "rgba(255, 255, 255, 0.36)",
}

export const topNavInfoChipSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.42rem",
  height: "2.4rem",
  padding: "0.38rem 0.8rem",
  borderRadius: borderRadiusBoxes,
  border: "1px solid rgba(173, 227, 255, 0.34)",
  backgroundColor: "#237ca6ad",
  color: "rgba(255, 255, 255, 0.96)",
  boxSizing: "border-box",
  lineHeight: 1,
}

export const topNavMetricsCardSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.85rem",
  height: "2.4rem",
  padding: "0.38rem 0.8rem",
  borderRadius: borderRadiusBoxes,
  border: "1px solid rgba(173, 227, 255, 0.2)",
  backgroundColor: "#237ca6ad",
  color: "rgba(255, 255, 255, 0.96)",
  boxSizing: "border-box",
  lineHeight: 1,
}

export const planInfoValueSx = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "rgba(255, 255, 255, 0.88)",
}

export const planBadgeSx = {
  ...topNavInfoChipSx,
  fontWeight: 700,
}

// Input base del buscador de dispositivos.
export const searchInputSx = {
  width: "100%",
  flex: 1,
  border: "none",
  outline: "none",
  backgroundColor: "transparent",
  color: themePalette.text.primary,
  fontSize: "0.95rem",
}

// Boton que abre el panel de filtros.
export const filterButtonSx = {
  ...iconAccentButtonSx,
}

// Titulo visual de cada seccion de filtros.
export const filterSectionTitleSx = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: themePalette.text.section,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  margin: "0 0 0.45rem",
}

// Estado inicial vacio para todos los filtros disponibles.
export const initialFilterState = {
  activity: [],
  products: [],
  cloudAccess: [],
  nodeAssociation: [],
}

// Estilo base compartido por los botones de accion.
export const actionButtonBaseSx = {
  width: "220px",
  minHeight: "36px",
  padding: "0.45rem 0.85rem",
  borderRadius: borderRadiusBoxes,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8rem",
  boxShadow: "none",
}

// Colores principales del panel derecho.
export const rightPanelTitleColor = themePalette.text.section
export const rightPanelAccentColor = themePalette.primary.main

// Estilos reutilizados para scrollbars personalizadas.
export const webkitScrollbar = theme.scrollbars.webkitScrollbar

export const webkitscrollbarTrack = theme.scrollbars.webkitScrollbarTrack
